define('widgets/form_number_field/viewmodel',['require'],function (require) {

    var Widget = function (element, settings) {
    };

    Widget.prototype.activate = function (settings) {
        var self = this;

        self.field = settings.field;
        self.hasFocus = ko.observable(false);
        self.hasBeenUpdated = ko.observable(false);
        self.isBusy = ko.observable(false);

        self.isDisabled = ko.computed(function () {
            return self.isBusy() || !self.field.editable();
        });

        self.isDisabled.subscribe(function (newValue) {
            if (numericTextBox)
                numericTextBox.enable(!newValue);
        });

        var dirtyFlag = new ko.DirtyFlag([self.field.value]);
        self.isDirty = ko.computed(function () {
            return dirtyFlag().isDirty();
        });

        self.showUpdatedIndicator = ko.computed(function () {
            return !self.hasFocus() && !self.isDirty() && self.hasBeenUpdated();
        });

        self.field.value.subscribe(function (newValue) {
            if (numericTextBox) {
                numericTextBox.value(newValue);
            }
        });

        self.readOnlyValue = ko.computed(function () {
            var format = self.field.options() && self.field.options().format ? self.field.options().format : "n";
            return kendo.toString(self.field.value(), format);
        });

        self.field.editable.subscribe(function (newValue) {
            self.hasBeenUpdated(false); // reset
        });

        self.field.editLayout = ko.observable(false);
        self.field.editLayout.focus = function () { }; //placeholder
        self.field.editLayout.isFocus = ko.observable(false);
        self.field.editLayout.editList = function () { };

        self.errors = ko.validation.group(self.field);
        self.isValid = ko.computed(function () {
            return self.errors().length == 0;
        });


        var numericTextBox;
        self.attached = function (viewHtml) {
            var options = self.field.options() || {};
            options.change = onChange;
            numericTextBox = $("input[type=text]", viewHtml).kendoNumericTextBox(options).data("kendoNumericTextBox");

            $("input.controls-is-visible:checkbox", viewHtml).change(function () {
                self.field.visible(this.checked);
            });
        };

        function onChange() {
            // if value didn't actually change then get out of here...
            var currentText = self.field.value() || "";
            if (currentText == numericTextBox.value())
                return;

            update(numericTextBox.value());
        }

        function update(value) {
            self.field.value(value);
            self.hasFocus(false);
            self.isBusy(true);
            if (self.isValid()) {
                settings.update(self.field)
                    .done(function () {
                        self.hasBeenUpdated(true);
                        dirtyFlag().reset();
                    })
                    .always(function () {
                        self.isBusy(false);
                    });
            } else {
                self.errors.showAllMessages();
                self.isBusy(false);
            }
        }
    };

    return Widget;
});
